import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatButtonModule } from "@angular/material/button";
import { DialogModule } from "@modules/shared/modules/dialog/dialog.module";
import { TranslateModule } from "@ngx-translate/core";
import { FormErrorDirective } from "@modules/shared/_directives/form-error.directive";
import { NgxMatInputTelComponent } from "ngx-mat-input-tel";
import { ClientDialogComponent } from "./components/client-dialog/client-dialog.component";

@NgModule({
  declarations: [ClientDialogComponent],
  exports: [ClientDialogComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    DialogModule,
    TranslateModule,
    FormErrorDirective,
    NgxMatInputTelComponent,
  ],
})
export class ClientSharedModule {}
